import React, { ReactElement, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getGif, getFocusedGif } from "../../state/selectors";
import { focusGif } from "../../state/actions";

interface Props {
  gifId: string;
}

function ListItem({ gifId }: Props): ReactElement {
  /* Not using CSS for hover to avoid excessive images being loaded */
  const [isHovering, setHovering] = useState(false);
  const [isPreloaded, setPreloaded] = useState(false);
  const [isStillLoaded, setStillLoaded] = useState(false);
  const ref = useRef<HTMLLIElement>(null);

  const gif = useSelector(getGif(gifId));
  const dispatch = useDispatch();

  const style = {
    gridColumnEnd: `span ${getSpan(gif.previewSize.width)}`,
    gridRowEnd: `span ${getSpan(gif.previewSize.height)}`,
  };

  function onHover() {
    setHovering(true);
  }

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && !isPreloaded && isStillLoaded) {
          preloadImage({ url: gif.previewUrl });
          setPreloaded(true);
        }
      }
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [gif, ref, isStillLoaded, isPreloaded]);

  return (
    <li
      ref={ref}
      style={style}
      // onMouseEnter={onHover}
      // onMouseLeave={() => setHovering(false)}
      // onClick={() => dispatch(focusGif(gifId))}
      tabIndex={0}
    >
      <div
        className="object-cover w-full h-full relative rounded overflow-hidden text-white"
        style={{ backgroundColor: randColor(), minHeight: "5rem" }}
      />
    </li>
  );
}

export default React.memo(ListItem);

/*
  HELPERS
*/

function getSpan(size) {
  if (size > 250) {
    return 2;
  }

  return 1;
}

function randColor() {
  let colors = ["#FFAB0F", "#247AFD", "#FE46A5", "#0F9B8E", "#03719C"];

  return colors[Math.floor(Math.random() * colors.length)];
}

function preloadImage({ url }) {
  new Image().src = url;
}
